import { Link } from 'react-router-dom';
import { TOTAL_FILMS, TOTAL_MOVIES, TOTAL_SERIES } from '@/data/catalog';

const STATS = [
  { value: `${TOTAL_MOVIES}+`, label: '影视条目' },
  { value: `${TOTAL_FILMS}`, label: '电影作品' },
  { value: `${TOTAL_SERIES}`, label: '剧集作品' },
  { value: '5', label: '精选专题' },
];

export default function SiteIntro() {
  return (
    <section className="mt-16 w-full bg-background-100 py-14 md:mt-20 md:py-16">
      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-7">
          <h2 className="text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            关于大雷影视大全
          </h2>
          <p className="mt-2 font-label text-xs uppercase tracking-[0.28em] text-foreground-400">
            About Da Lei Film
          </p>
          <p className="mt-6 max-w-2xl text-sm leading-7 text-foreground-600 md:text-[15px]">
            大雷影视是一个为影视爱好者准备的内容发现平台。我们把最新上映的电影、正在更新的剧集，按地区、年份、类型与热度整理成清晰的列表，配上完整的演职员资料和剧情介绍，让你不用在几十个页面之间来回跳转。
          </p>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-600 md:text-[15px]">
            除了常规分类，我们还会围绕类型与主题制作专题合集，把同一类情绪的作品放在一起。想找一部适合深夜看的悬疑剧，或者一组能安心吃完晚饭的治愈片单，通常只需要点两次。
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/special/special-03"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              看看专题
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg bg-background-200">
            {STATS.map((stat) => (
              <div key={stat.label} className="bg-background-50 px-5 py-7">
                <p className="font-label text-4xl font-semibold leading-none tracking-tight text-primary-600">{stat.value}</p>
                <p className="mt-2 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs leading-relaxed text-foreground-400">
            数据说明：站内影视条目、评分与简介均为演示内容，用于展示产品结构与浏览体验。
          </p>
        </div>
      </div>
    </section>
  );
}